export default "__VITE_ASSET__d26ba175__"